import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { renderTitleWithStyledQuestionMarks } from './renderTitle';

import './Onboarding.css';

/**
 * Variante "bienvenida": tutorial inicial (3 pasos) con texto + ilustración.
 */
export const WelcomeOnboarding = ({ slides, onClose, onGoToRules }) => {
  const [onboardingStep, setOnboardingStep] = useState(0);

  const onNextTutorialStep = () => {
    setOnboardingStep((prev) => Math.min(prev + 1, slides.length - 1));
  };

  const goToRulesFromTutorial = () => {
    onClose();
    onGoToRules();
  };

  const isLastStep = onboardingStep === slides.length - 1;
  const isFirstStep = onboardingStep === 0;
  const currentSlide = slides[onboardingStep];

  if (!currentSlide) return null;

  return (
    <div className="home-onboarding-overlay" role="dialog" aria-modal="true">
      <div className="home-onboarding-popup">
        <div
          className={`home-onboarding-content ${
            isFirstStep ? 'home-onboarding-content--image-left' : ''
          }`}
        >
          <div className="home-onboarding-text">
            <h2>{renderTitleWithStyledQuestionMarks(currentSlide.title)}</h2>
            {currentSlide.paragraphs.map((paragraph, idx) => (
              <p key={`${currentSlide.id}-paragraph-${idx}`}>{paragraph}</p>
            ))}
          </div>
          <div className="home-onboarding-image">
            {currentSlide.imageSrc ? (
              <img src={currentSlide.imageSrc} alt={currentSlide.imageAlt} />
            ) : (
              <div className="home-onboarding-image-placeholder">
                Imagen paso {onboardingStep + 1}
              </div>
            )}
          </div>
        </div>
        <div className="home-onboarding-actions">
          {!isLastStep ? (
            <>
              <button
                type="button"
                className="home-onboarding-skip"
                onClick={onClose}
              >
                Omitir tutorial
              </button>
              <button
                type="button"
                className="home-onboarding-primary"
                onClick={onNextTutorialStep}
              >
                Siguiente
              </button>
            </>
          ) : (
            <>
              <button
                type="button"
                className="home-onboarding-secondary"
                onClick={goToRulesFromTutorial}
              >
                Consultar reglas
              </button>
              <button
                type="button"
                className="home-onboarding-primary"
                onClick={onClose}
              >
                ¡Empezar a jugar!
              </button>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

WelcomeOnboarding.displayName = 'WelcomeOnboarding';
WelcomeOnboarding.propTypes = {
  slides: PropTypes.arrayOf(PropTypes.object).isRequired,
  onClose: PropTypes.func.isRequired,
  onGoToRules: PropTypes.func.isRequired,
};

export default WelcomeOnboarding;
